module.exports = __webpack_public_path__ + "img/problem-statement-img.68c6ce27.png";